/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { BakendHttpResponse } from '../../bakend-http-response';
import { RequestBuilder } from '../../request-builder';

import { BackendMonitoringScenarioDetailDto } from '../../models/backend-monitoring-scenario-detail-dto';

export interface MonitoringScenariosRetrieve$Params {
  scenario_id: number;
}

export function monitoringScenariosRetrieve(
  http: HttpClient,
  rootUrl: string,
  params: MonitoringScenariosRetrieve$Params,
  context?: HttpContext,
): Observable<BakendHttpResponse<BackendMonitoringScenarioDetailDto>> {
  const rb = new RequestBuilder(rootUrl, monitoringScenariosRetrieve.PATH, 'get');
  if (params) {
    rb.path('scenario_id', params.scenario_id, {});
  }

  return http.request(rb.build({ responseType: 'json', accept: 'application/json', context })).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as BakendHttpResponse<BackendMonitoringScenarioDetailDto>;
    }),
  );
}

monitoringScenariosRetrieve.PATH = '/api/monitoring/scenarios/{scenario_id}/';
